import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useEffect, useState } from 'react'
import useReactApexChart from '../../hook/useReactApexChart'
import { Link } from "react-router-dom";
import apiProvider from '../../apiProvider/api';
import {IMAGE_URL} from "../../network/apiClient"
const ItemsPerPage = 10; // Number of items per page

const UnitCountTwo = () => {

    const [userData, setUserData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const fetchData = async () => {

        try { 
            const result = await apiProvider.getPurchaseDetails();
            console.log(result, "result");
            if (result && result.response && result.response.data && result.response.data.data) {
                setUserData(result.response.data.data.courses);
            }

        } catch (error) {
            console.error("Error fetching category data:", error);
        }
    };


    useEffect(() => {
        fetchData();
    }, []); // Empty dependency array means this runs once on mount

    // Calculate total pages
    const totalPages = Math.ceil(userData && userData.length >0 && userData.length / ItemsPerPage);

    // Get the current page's data
    const startIndex = (currentPage - 1) * ItemsPerPage;
    const endIndex = startIndex + ItemsPerPage;
    const currentData = userData && userData.length && userData.slice(startIndex, endIndex);

    // Handle page change
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const formatDate = (isoString) => {
        const date = new Date(isoString);
        return date.toLocaleString('en-IN', {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    return (
        <div className="card h-100 p-0 radius-12">

            <div className="card-body p-24">
                <div className="table-responsive scroll-sm">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr>
                                <th scope="col">
                                    <div className="d-flex align-items-center gap-10">
                                        S.No
                                    </div>
                                </th>
                                <th scope="col">User Name</th>
                                <th scope="col">Course Name</th>
                                <th scope="col">Image</th>
                                {/* <th>Type</th> */}
                                <th scope="col">Duration</th>
                                <th scope="col">Language</th>
                                <th scope="col">Purchase Status</th>
                                <th scope="col">Purchase Date</th>
                                {/* <th scope="col">Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Country</th>
                                <th scope="col">Phone No</th>
                                <th scope="col">Message</th> */}

                                {/* <th scope="col" className="text-center">
                                            Status
                                        </th>
                                        <th scope="col" className="text-center">
                                            Action
                                        </th> */}
                            </tr>
                        </thead>
                        <tbody>

                            {currentData && currentData.length > 0 && currentData.map((item, index) => (
                                <tr key={item.id}>
                                    <td>
                                        <div className="d-flex align-items-center gap-10">
                                            {index + 1}
                                        </div>
                                    </td>
                                    {/* <td>{item.id}</td> */}
                                    <td>
                                        <span className="text-md mb-0 fw-normal text-secondary-light">
                                            {item.userName}
                                        </span>
                                    </td>
                                    <td className="pro-title text-decoration-none">
                                        <p className="pro-title text-decoration-none">{item.categoryName}</p>
                                        <p>{item.courseName}</p>
                                    </td>
                                    <td className="pro-thumbnail">
                                        <img
                                            src={IMAGE_URL + item.categoryImage}
                                            alt="Product"
                                            style={{ width: "70px" }}
                                        />
                                    </td>

                                    <td>3 Days</td>
                                    <td>{item.lang}</td>
                                    <td>{item.paymentStatus}</td>
                                    <td>{formatDate(item.purchaseDate)}</td>

                                    {/* <td className="text-center">
                                                <span className={`${item.isActive
                                                    ? "bg-success-focus text-success-600 border border-success-main"
                                                    : "bg-neutral-200 text-neutral-600 border border-neutral-400"
                                                    } px-24 py-4 radius-4 fw-medium text-sm`}>
                                                    {item.isActive}
                                                </span>
                                            </td> */}
                                    <td className="text-center">
                                        <div className="d-flex align-items-center gap-10 justify-content-center">
                                            {/* <button
                                                        type="button"
                                                        className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    >
                                                        <Icon
                                                            icon="majesticons:eye-line"
                                                            className="icon text-xl"
                                                        />
                                                    </button> */}
                                            {/* <button
                                                        type="button"
                                                        className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    >
                                                        <Icon icon="lucide:edit" className="menu-icon" />
                                                    </button> */}
                                            {/* <button
                                                        type="button"
                                                        className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    >
                                                        <Icon
                                                            icon="fluent:delete-24-regular"
                                                            className="menu-icon"
                                                        />
                                                    </button> */}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                        <span>
                            Showing {startIndex + 1} to {Math.min(endIndex, currentData.length)} of {currentData.length} entries
                        </span>
                        <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                            {/* Previous Page Button */}
                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                <Link
                                    className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                    to="#"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                >
                                    <Icon icon="ep:d-arrow-left" />
                                </Link>
                            </li>

                            {/* Page Numbers */}
                            {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className="page-item">
                                    <Link
                                        className={`page-link fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${currentPage === i + 1 ? "bg-primary-600 text-white" : "bg-neutral-200 text-secondary-light"
                                            }`}
                                        to="#"
                                        onClick={() => handlePageChange(i + 1)}
                                    >
                                        {i + 1}
                                    </Link>
                                </li>
                            ))}

                            {/* Next Page Button */}
                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                <Link
                                    className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                    to="#"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                >
                                    <Icon icon="ep:d-arrow-right" />
                                </Link>
                            </li>
                        </ul>
                    </div>
                )}
            </div>
        </div>
        // <div className='card basic-data-table'> 
        //     <div className='card-body py-80 px-32 text-center'>
        //         <h6 className='mb-16'>No Purchase Data</h6>
        //         <p className='text-secondary-light'>
        //             It looks like there are no course purchases yet. Once someone buys a course, it will appear here.
        //         </p>

        //     </div>
        // </div>
    )
}

export default UnitCountTwo